import { ChangeDetectionStrategy, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FireBusinessAssessmentService } from 'src/app/services/fire-business-assessment-services/fire-business-assessment.service';
import { ActivatedRoute, Router } from "@angular/router"; // ActivatedRoue is used to get the current associated components information.
import { Location } from '@angular/common';  // Location service is used to go back to previous component
import * as firebase from 'firebase/app';
import { DataSnapshot } from '@angular/fire/database/interfaces';
import { CommonModule } from '@angular/common';
import * as html2pdf from 'html2pdf.js';
import { AuthGuard } from 'src/app/shared/guard/auth.guard';
import { HttpClient } from '@angular/common/http';
import { filter, first } from 'rxjs/operators';
import { FormGroup } from '@angular/forms';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from 'src/app/shared/service/auth.service';
import {assessmentBusinessApiEndpoint} from 'src/app/consts/conts.global'; 

interface ImplementationStatus {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-views-practical',
  templateUrl: './views-business-assessment.component.html',
  styleUrls: ['./views-business-assessment.component.scss'],
})


export class ViewsBusinessAssessmentComponent implements OnInit {

  probSolvStat: string;
  teamExecutionStat:string;
  industryCondStat:string;

  statResp: ImplementationStatus[] = [
    {value: 'no', viewValue: 'No'},
    {value: 'yes', viewValue: 'Yes'},
  ];

  //implement Read More
  isReadMore = true;
  pendingData = true;
  
  showShortSustScoreDescription = true;
  showShortModelScoreDescription = true;
  showShortOperatingScoreDescription = true;
  showShortStratDesciption = true;
  showShortModelStratDesciption  =true;
  showShortOperationsStratDesciption = true;
  showShortOperationsMarketingDesciption = true; 
  showShortModelMarketingDesciption = true;
  showShortFinOpDesciption = true;
  showShortLegalDesciption = true;
  showShortTeamOperationsDesciption = true;
  showShortTeamDynamicDesciption = true;
  showShortOperationDesciption = true;
  showTxtDescription = true;
  sustScoreText() {
    this.showShortSustScoreDescription = !this.showShortSustScoreDescription 
 }
 modelScoreText() {
  this.showShortModelScoreDescription = !this.showShortModelScoreDescription 
}
 operatingScoreText() {
  this.showShortOperatingScoreDescription = !this.showShortOperatingScoreDescription 
}
stratText() {
     this.showShortStratDesciption = !this.showShortStratDesciption 
  }
stratModelText() {
    this.showShortModelStratDesciption = !this.showShortModelStratDesciption 
 }
 stratOperationsText() {
  this.showShortOperationsStratDesciption = !this.showShortOperationsStratDesciption 
}
  
marketingOperationsText () {
  this.showShortOperationsMarketingDesciption = !this.showShortOperationsMarketingDesciption
}
marketingModelText () {
  this.showShortModelMarketingDesciption = !this.showShortModelMarketingDesciption
} 
legalText() {
  this.showShortLegalDesciption = !this.showShortLegalDesciption
}
finOpText() {
  this.showShortFinOpDesciption = !this.showShortFinOpDesciption
}
teamOperationsText () {
  this.showShortTeamOperationsDesciption = !this.showShortTeamOperationsDesciption
  
}
teamDynamicsText () {
  this.showShortTeamDynamicDesciption = !this.showShortTeamDynamicDesciption
  
}
operationsText () {
  this.showShortOperationDesciption = !this.showShortOperationDesciption
}
showTxt() {
  this.showTxtDescription = !this.showTxtDescription;
}


 
  constructor(
    public fireBusinessAssessment: FireBusinessAssessmentService,
    private router: Router,
    private location: Location,
    private actRoute: ActivatedRoute,
    private firestoredb: AngularFirestore,
    private guard: AuthGuard,
    private http: HttpClient,
    public authService:AuthService

  ) {

   }



  //declare form variable here

  data!: any;
  public excellent: string = 'Excellent';
  public good: string = 'Good';
  public average: string = 'Average';
  public belowAverage: string = 'Below Average';
  public poor: string = 'Poor';
  public actionItemForm: FormGroup;

  
  assessmentPayload: any;
  assessmentDate: any;

  @ViewChild('operating') operating: ElementRef;

  ngOnInit(): void {
    this.getAssessmentId();
    this.barriersLeftArray();
  }

 
  getAssessmentId() {
    const id = this.actRoute.snapshot.paramMap.get('id');
    this.getAssessmentData(id);
  }
   assessmentInput: any;
 /* getAssessmentData(id: string) {
    //define all variables of a single assessment
    this.http.get(`${assessmentBusinessApiEndpoint}?key=${id}`)
    .pipe(first())
    .subscribe((payload: any) => {
      debugger
      this.assessmentPayload = payload['value']; 
      console.info(this.assessmentPayload?.key); 
      this.assessmentInput = this.firePracticalAssessment.readSustainibleAssessment(`${id}`)
      .get()
      .toPromise()
      .then((snapshot) => {
      this.data = snapshot.data();
     // this.showOperating();
      this.pendingData = false;
   //  this.fillActionItemArray();
   //  this.assessmentDate = this.assessmentPayload?.createdAt.toDate();
    });
  });
}*/

getAssessmentData(id: string) {
  debugger
  //define all variables of a single assessment
  this.firestoredb
    .collection('business-assessment-results')
    .doc(id)
    .snapshotChanges()
    .pipe(filter((data) => data.payload.exists))
    .subscribe((data: any) => {
      this.assessmentPayload = data.payload.data(); //took out .value
      console.log("this.data" + this.assessmentPayload)
      this.pendingData = false;
     
    });
  this.assessmentInput = this.fireBusinessAssessment
    .readSustainibleAssessment(`${id}`)
    .get()
    .toPromise()
    .then((snapshot) => {
      this.data = snapshot.data()
      console.log("this.data" + this.data)
    });
}

actionItemArray = [];
notRegisteredAction = ["Register your business"];

fillActionItemArray(){
if (this.data.busiRegType.name === "Not Registered") 
this.actionItemArray.push(this.notRegisteredAction)

}

  goBack() {
    this.location.back();
  }

  exportOnClick() {
    const options = {
      filename: 'Sustainible_Recommendations.pdf',
      image: { type: 'jpeg' },
      html2canvas: {},
      jsPDF: { orientation: 'portrait' },
      margin: 12,
      pagebreak: { mode: 'avoid-all' }
    };

    const content: Element = document.getElementById('element-to-export');

    html2pdf()
      .from(content)
      .set(options)
      .save();
  }

  public show: boolean = true;
  public hide: boolean = false;

  toggle() {
    this.show = !this.show;
    this.hide = !this.hide;
  }

  showOperating() {
    
    if (this.data?.practicalCompHistoryExistingCompany?.name == "Yes") {
        this.operating.nativeElement.style.display = 'block';
      }
      else if (this.data?.practicalCompHistoryExistingCompany?.name == "No") {
        this.operating.nativeElement.style.display = 'none';
      }
    }

    step = 0;

    setStep(index: number) {
      this.step = index;
    }
  
    nextStep() {
      this.step++;
    }
  
    prevStep() {
      this.step--;
    }



    barriersLeftArray()  {
      debugger
       let existingBarriersFullArray = [];
       let teamtoGetArray = [];
       let existingBarriersNameArray = [];
       const teamUnadvNameArray = [
         { value: 1, name: 'Tech Challenges' },
         { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
         { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
         { value: 1, name: 'Startup costs/Access to capital' },
       ];
       const offerMarkBarNameArray =  [
         { value: 1, name: 'Tech Challenges' },
         { value: 1, name: 'Government Regulation (Licensing, permits, etc.)', },
         { value: 1, name: 'Startup costs/Access to capital' },
         { value: 1, name: 'High research and development costs' },
         { value: 1, name: 'Ownership of Raw Materials' },
         { value: 1, name: 'Business Owner Education or Skills' },
         { value: 1, name: 'Personal Network, it`s about who you know' },
         { value: 1, name: 'Selling enough to make money on each (Economies of Scale)' },
         { value: 1, name: 'Network Effect, Sales' },
         { value: 1, name: 'Brand loyalty' },
         { value: 1, name: 'Access to suppliers and distribution channels' },
         { value: 0, name: 'None of the above' },
       ];
   
     
       teamtoGetArray = offerMarkBarNameArray.filter((x: { name: any; }) => !teamUnadvNameArray.find(rm => (rm.name === x.name)));
       existingBarriersFullArray = offerMarkBarNameArray.filter((x: { name: any; }) => !teamUnadvNameArray.find(rm => (rm.name === x.name)));
       for (let i = 0; i < existingBarriersFullArray.length; i++) {
         existingBarriersNameArray.push(existingBarriersFullArray[i].name)
       }
   
    /*  for (let i = 0; i < offerMarkBarNameArray.length; i++) {// biggest then smallest worked wehn offer was biggest
        for (let j = 0; j < teamUnadvNameArray.length; j++) {
            if (offerMarkBarNameArray[i].name != teamUnadvNameArray[j].name) { 
            if (teamUnadvNameArray[j].name != "None of the above"){
             existingBarriersArrayDuplicate.push(offerMarkBarNameArray[i].name);
            }
           }
         }
     }*/
    /* existingBarriersArray = existingBarriersArrayDuplicate.filter(function(elem, index, self) {
       return index === self.indexOf(elem);
   })*/
   
       //return existingBarriersArray;
     };
   
  }



